import {makeStyles} from "@material-ui/core";

export const AutoInputStyle = makeStyles((theme) => ({
      textField: {
        width: '97%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    textFieldMultiLinea: {
      width: '95%',
      margin: "5px",
      paddingBottom: 0,
      fontWeight: 500
    },
    formControl: {
      width: "90%",
      margin: "5px"
    },
    containerSpacing:{
      margin: "10px 5px",
      padding: "10px 10px"
    },
    containerSpacingItem:{
      margin: "10px 10px"
    },
    modalBotonesCenter:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalBotones:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    modalBoton:{
      margin: "15px 10px",
      width: "20%"
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: "1200px",
      margin: "0 auto",
      padding: theme.spacing(1),
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: 'none',
      boxShadow: theme.shadows[10],
      padding: theme.spacing(1, 2, 1),
    },
  }));
